/* PDP — Interactividad client-side
   Deps: global.js maneja ATC, qty, thumb switcher */
(function () {

  /* ── VARIANTES: radio cards → sync hidden input + price ── */
  var variantIdInput = document.getElementById('product-variant-id');
  var buyboxPrice    = document.getElementById('pdp-h-price');
  var mainImage      = document.getElementById('pdp-main-image');
  var galleryThumbs  = document.querySelectorAll('.pdp__thumb');
  var atcDefaultText = (function () {
    var t = document.getElementById('add-to-cart-text');
    return (t && t.textContent) ? t.textContent.split('·')[0].trim() : 'Agregar al carrito';
  })();

  /* syncVariantImage: cambia la foto principal a la foto de la variante.
     DEGRADACIÓN ELEGANTE: Liquid solo emite data-img-src si Shopify tiene una foto
     asignada a esa variante. Sin foto → salimos sin tocar nada: la galería se queda
     exactamente como está (ni parpadeo, ni imagen rota, ni salto de layout).
     Funciona hoy aunque no haya ni una sola foto asignada todavía. */
  function syncVariantImage(radio) {
    var src = radio.getAttribute('data-img-src');
    if (!src || !mainImage) return;

    /* Mismo criterio que el thumb switcher de global.js: limpiar srcset/sizes antes
       del src, si no el browser conserva la imagen vieja por el descriptor de srcset. */
    mainImage.removeAttribute('srcset');
    mainImage.removeAttribute('sizes');
    mainImage.src = src;
    var alt = radio.getAttribute('data-img-alt');
    if (alt) mainImage.alt = alt;

    /* Sync del estado active de las miniaturas: si la foto de la variante está entre
       ellas se marca; si no está (p. ej. la cortó thumbs_limit), ninguna queda activa
       en vez de dejar una activa que ya no corresponde a la foto mostrada. */
    var imageId = radio.getAttribute('data-image-id');
    galleryThumbs.forEach(function (t) {
      var match = imageId && t.getAttribute('data-image-id') === imageId;
      t.classList.toggle('active', !!match);
      t.setAttribute('aria-pressed', match ? 'true' : 'false');
    });
  }

  /* syncVariant: aplica una variante (radio) a hidden input, buybox, sticky, CTA y foto.
     pushUrl=false en el sync inicial para no ensuciar el history al cargar.
     syncImage=false en el sync inicial: Liquid ya renderizó la foto de la variante
     server-side, volver a asignarla dispararía una request extra y un parpadeo. */
  function syncVariant(radio, pushUrl, syncImage) {
    if (!radio) return;
    var variantId      = radio.value;
    var priceFormatted = radio.getAttribute('data-price-formatted') || '';

    if (variantIdInput) variantIdInput.value = variantId;

    /* sync precio del buybox (incluye pill activa en CSS via :checked) */
    if (buyboxPrice && priceFormatted) buyboxPrice.textContent = priceFormatted;

    /* sync de la sticky bar movil (precio, variante, estado del boton) */
    var stPrice   = document.getElementById('pdp-sticky-price');
    var stVariant = document.getElementById('pdp-sticky-variant');
    var stBtn     = document.getElementById('pdp-sticky-btn');
    if (stPrice && priceFormatted) stPrice.textContent = priceFormatted;
    if (stVariant) stVariant.textContent = radio.getAttribute('data-title') || '';
    if (stBtn) {
      stBtn.disabled = radio.disabled;
      stBtn.textContent = radio.disabled ? 'Agotado' : (stBtn.getAttribute('data-label') || 'Agregar');
    }

    /* marca .is-checked en la pill seleccionada (para hover anim) */
    document.querySelectorAll('.pdp-h__variant').forEach(function (lbl) {
      lbl.classList.remove('is-checked');
    });
    var lbl = radio.closest('.pdp-h__variant');
    if (lbl) lbl.classList.add('is-checked');

    if (syncImage) syncVariantImage(radio);

    var atcBtn  = document.getElementById('add-to-cart');
    var atcText = document.getElementById('add-to-cart-text');
    var disabled = radio.disabled;
    if (atcBtn)  atcBtn.disabled = disabled;
    if (atcText) {
      if (disabled) {
        atcText.textContent = 'Agotado';
      } else {
        atcText.textContent = atcDefaultText;
      }
    }

    if (pushUrl && history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      history.replaceState({}, '', url.toString());
    }
  }

  var variantRadios = document.querySelectorAll('.pdp-h__variant input[type="radio"]');
  variantRadios.forEach(function (radio) {
    radio.addEventListener('change', function () {
      if (!radio.checked) return;
      syncVariant(radio, true, true);
    });
  });

  /* Sync inicial: alinea sticky bar / buybox / CTA con la variante ya seleccionada
     (la "mejor valor" resuelta en Liquid), sin esperar a un 'change' del usuario.
     Cubre el mismatch precio-mostrado vs producto-agregado y el estado agotado. */
  (function initVariantSync() {
    var checked = null;
    variantRadios.forEach(function (r) { if (r.checked) checked = r; });
    if (checked) syncVariant(checked, false, false);
  })();

  /* ── FAQ: sync aria-expanded ── */
  document.querySelectorAll('.pdp-h__faq-item').forEach(function (detail) {
    var summary = detail.querySelector('summary');
    if (!summary) return;
    detail.addEventListener('toggle', function () {
      summary.setAttribute('aria-expanded', detail.open ? 'true' : 'false');
    });
  });

  /* ── REVIEW FILTER TABS ── */
  document.querySelectorAll('.pdp-h__filter-tab').forEach(function (tab) {
    tab.addEventListener('click', function () {
      document.querySelectorAll('.pdp-h__filter-tab').forEach(function (t) {
        t.classList.remove('is-active');
        t.setAttribute('aria-selected', 'false');
      });
      tab.classList.add('is-active');
      tab.setAttribute('aria-selected', 'true');
    });
  });

  /* ── PRODUCT RECOMMENDATIONS (fallback cross-sell) ── */
  var recsEl = document.getElementById('pdp-recommendations');
  if (recsEl) {
    var recsUrl = recsEl.getAttribute('data-url');
    if (recsUrl) {
      fetch(recsUrl)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var parser = new DOMParser();
          var doc    = parser.parseFromString(html, 'text/html');
          var inner  = doc.getElementById('pdp-recommendations');
          if (inner) recsEl.innerHTML = inner.innerHTML;
        })
        .catch(function () {});
    }
  }

  /* ── S8: Sticky ATC móvil ──────────────────────────────────────────
     Guarda 2 de 2 (la 1 es display:none del CSS fuera de <750px): el
     observer solo corre cuando el media query móvil matchea. Se muestra
     únicamente cuando el buybox sale del viewport; el botón dispara el
     submit del form real del hero (un solo camino AJAX al carrito). */
  (function stickyAtc() {
    var bar = document.getElementById('pdp-sticky-bar');
    if (!bar || !('IntersectionObserver' in window)) return;
    var anchor = document.querySelector('#pdp-h-hero .pdp-h__actions') ||
                 document.getElementById('product-form');
    if (!anchor) return;

    var mq = window.matchMedia('(max-width: 749px)');

    function setVisible(show) {
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }

    var buyboxOut = false;
    var io = new IntersectionObserver(function (entries) {
      buyboxOut = !entries[0].isIntersecting;
      setVisible(mq.matches && buyboxOut);
    }, { rootMargin: '-56px 0px 0px 0px' });
    io.observe(anchor);

    /* al cruzar el breakpoint, re-evalúa sin esperar scroll */
    var onMq = function () { setVisible(mq.matches && buyboxOut); };
    if (mq.addEventListener) mq.addEventListener('change', onMq);
    else if (mq.addListener) mq.addListener(onMq);

    var btn = document.getElementById('pdp-sticky-btn');
    var form = document.getElementById('product-form');
    if (btn && form) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        if (form.requestSubmit) form.requestSubmit();
        else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      });
    }
  })();

})();
